<div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroMagnifyingGlassCircle" ></ng-icon>
      <div>
          <h2>Search Report
          </h2>
      </div>
    </div>
  </div>
<div class="inner-box">
    <mat-card class="hide-stepper" class="without-expansion">
        <mat-card-content class="form-head">
    <!-- <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
              <div class="col-md-12 p-0 flex-wrap d-flex">
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Select Contract Types</mat-label>
                      <input type="text" matInput [matAutocomplete]="auto" formControlName="contractTypeName"
                             (input)="onInputChange($event.target.value)" #contractInput [errorStateMatcher]="matcher">
                             <mat-chip-listbox>
                              <mat-chip *ngFor="let value of selectedValues" [removable]="true" (removed)="removeValue(value)">
                                {{ value.name }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                              </mat-chip>
                            </mat-chip-listbox>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                        <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
            
                      <mat-error *ngIf="searchForm.get('contractTypeName').hasError('required')">
                        Contract Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                 
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Contract Status</mat-label>
                      <mat-select formControlName="contractStatus" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let contract of contractStatus" [value]="contract.id">{{contract.name
                          }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Transaction Type</mat-label>
                      <mat-select formControlName="transactionTypeId" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let trans of transactions" [value]="trans.id">{{ trans.name
                          }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('transactionTypeId')?.hasError('required')">
                        Transaction Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Obligation Type</mat-label>
                      <mat-select formControlName="entitlementTypeId" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let obligation of obligationTypes" [value]="obligation.id">{{
                          obligation.name
                          }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('entitlementTypeId')?.hasError('required')">
                        Obligation Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Obligation Status</mat-label>
                      <input type="text" matInput autocomplete="off" formControlName="obligationStatus"
                        [errorStateMatcher]="matcher">
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Actions</mat-label>
                      <mat-select formControlName="action"  multiple>
                        <mat-option *ngFor="let option of actionType" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('action').hasError('required')">
                        Number Of Employee is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Users</mat-label>
                      <mat-select formControlName="users" [errorStateMatcher]="matcher"  multiple>
                        <mat-option *ngFor="let user of allUsers" [value]="user.id">{{ user.firstName +" "+ user.lastName
                          }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Meta Data</mat-label>
                      <mat-select formControlName="metaData">
                        <mat-option *ngFor="let meta of metaData" [value]="meta">{{ meta }}</mat-option>
                    </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                  <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Enter a date range</mat-label>
                          <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start date" formControlName="startDate"[errorStateMatcher]="matcher">
                            <input matEndDate placeholder="End date" formControlName="endDate"[errorStateMatcher]="matcher">
                          </mat-date-range-input>
                          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker></mat-date-range-picker>
                          <mat-error *ngIf="searchForm.get('startDate').hasError('required')">
                            Select Start Date
                          </mat-error>
                          <mat-error
                            *ngIf="searchForm.get('startDate').invalid && !searchForm.get('startDate').hasError('required')">
                            Start Date is invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  <div class="col-md-4">
                    <div class="dense-2">

                      <div class="d-flex col-md-12 justify-content-end p-0">
                        <button color="primary  " class="outlined-btn" mat-raised-button (click)="reset()" type="reset"
                        [disabled]="isLoading">Reset</button>
                        
                       <button mat-raised-button  class="ml-3" color="accent" >Search</button> 
                       <button color="accent" mat-raised-button class="ml-3" type="submit" [disabled]="searchForm.invalid">Save</button>
                      </div>  
                      
                    </div>
                  </div> 
              </div>
              
      </form> -->

      <div class="col-md-12 common-table-style p-0" >
          <div>
            <p-table
                #dt
                [columns]="contractList"
                [responsive]="true"  
                [value]="contractList"
                [(selection)]="selectedContract"
                dataKey="id"
                [rowHover]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                [paginator]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [filterDelay]="0"
                [globalFilterFields]="['contractName', 'contractType', 'createdBy', 'status','updateDate']"
            >
                <ng-template pTemplate="caption">
           
                
                    <div  class="search" >
                      
                      <button pButton label="Clear" class="p-button-outlined pi pi-filter-slash btn" (click)="clear(dt)"></button>
                      <p-multiSelect class="mr-2" [options]="cols" [(ngModel)]="selectedContract" optionLabel="header"
                      selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}" placeholder="Choose Columns"></p-multiSelect>
                        <span class="p-input-icon-left mr-2">
                          <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                        </span>
                        <span >
                           <!-- <button type="button" pButton pRipple (click)="exportPdf()" class="p-button-danger mr-2 pi pi-file-pdf"  style="font-size: 1.3rem"pTooltip="PDF" tooltipPosition="bottom"></button> -->
                          <i  (click)="exportExcel()" class="mr-2 pi pi-file-excel"  style="font-size: 1.5rem; color: green"></i></span>
                         
                         
              
                    </div>
                    
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="contractName" style="min-width: 14rem">
                            <div class="flex justify-content-between align-items-center">
                                Contract Name
                                <p-sortIcon field="contractName"></p-sortIcon>
                                <p-columnFilter type="text" field="contractName" display="menu" class="ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="contractType" style="min-width: 14rem">
                            <div class="flex justify-content-between align-items-center">
                                Contract Type
                                <p-sortIcon field="contractType"></p-sortIcon>
                                <p-columnFilter type="text" field="contractType" display="menu" class="ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="created.name" style="min-width: 14rem">
                          <div class="flex justify-content-between align-items-center"> 
                              Created By
                              <p-sortIcon field="created.name"></p-sortIcon>
                              <p-columnFilter field="created.name" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                  <ng-template pTemplate="header">
                                      <div class="px-3 pt-3 pb-0">
                                          <span class="font-bold">Created By</span>
                                      </div>
                                  </ng-template>
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                      <p-multiSelect [ngModel]="value" [options]="created" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name">
                                          <ng-template let-option pTemplate="item">
                                              <div class="inline-block vertical-align-middle">
                                          
                                                  <span class="ml-1 mt-1">{{ option.name }}</span>
                                              </div>
                                          </ng-template>
                                      </p-multiSelect>
                                  </ng-template>
                              </p-columnFilter>
                          </div>
                      </th>
                      <!-- <th pSortableColumn="createdBy" style="min-width: 10rem">
                        <div class="flex justify-content-between align-items-center">
                            createdBy
                            <p-sortIcon field="contractName"></p-sortIcon>
                            <p-columnFilter field="contractName" matchMode="equals" display="menu" class="ml-auto" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [ngModel]="value" [options]="contractName" (onChange)="filter($event.value)" placeholder="Any">
                                        <ng-template let-option pTemplate="item">
                                            <p-tag [value]="option.name" ></p-tag>
                                        </ng-template>
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th> -->
                    <th pSortableColumn="createDate" style="min-width: 10rem">
                      <div class="flex justify-content-between align-items-center">
                          Create Date
                          <p-sortIcon field="createDate"></p-sortIcon>
                          <p-columnFilter  type="date" field="createDate" display="menu" class="ml-auto" ></p-columnFilter>
                      </div>
                  </th>
                  <th pSortableColumn="updateDate" style="min-width: 10rem">
                      <div class="flex justify-content-between align-items-center">
                          Last Update
                          <p-sortIcon field="updateDate"></p-sortIcon>
                          <p-columnFilter  type="date" field="updateDate" display="menu" class="ml-auto"></p-columnFilter>
                      </div>
                  </th>
                  
                        <th pSortableColumn="status" style="min-width: 10rem">
                            <div class="flex justify-content-between align-items-center">
                                Status
                                <p-sortIcon field="status"></p-sortIcon>
                                <p-columnFilter field="status" matchMode="equals" display="menu" class="ml-auto">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)" placeholder="Any">
                                            <ng-template let-option pTemplate="item">
                                                <p-tag [value]="option.label" ></p-tag>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <!-- <th pSortableColumn="activity" style="min-width: 10rem">
                            <div class="flex justify-content-between align-items-center">
                                Activity
                                <p-sortIcon field="activity"></p-sortIcon>
                                <p-columnFilter field="activity" matchMode="between" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                    <ng-template pTemplate="filter" let-filter="filterCallback">
                                        <p-slider [ngModel]="activityValues" [range]="true" (onSlideEnd)="filter($event.values)" styleClass="m-3"></p-slider>
                                        <div class="flex align-items-center justify-content-between px-2">
                                            <span>{{ activityValues[0] }}</span> 
                                            <span>{{ activityValues[1] }}</span>
                                        </div>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th> -->
                        <!-- <th style="width: 3rem">
                          <div class="flex justify-content-between align-items-center">
                            verified
                              <p-columnFilter type="boolean" field="verified" display="menu"></p-columnFilter>
                          </div>
                      </th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-contractList>
                    <tr class="p-selectable-row">
                        <td>
                            <p-tableCheckbox [value]="contractList"></p-tableCheckbox>
                        </td>
                        <td>
                            <span class="p-column-title">Contract Name</span>
                            {{ contractList.contractName }}
                        </td>
                        <!-- <td>
                            <span class="p-column-title">Country</span>
                            <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + customer.country.code" style="width: 20px" />
                            <span class="ml-1 vertical-align-middle">{{ contractList.contractType }}</span>
                        </td> -->
                        <!-- <td>
                            <span class="p-column-title">contractName</span>
                            <img [alt]="contractList.representative.name" src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{ contractList.representative.image }}" width="32" style="vertical-align: middle" />
                            <span class="ml-1 vertical-align-middle">{{ contractList.createdBy }}</span>
                        </td> -->
                        <td>
                            <span class="p-column-title">Contract Type</span>
                            {{ contractList.contractType  }}
                        </td>
                        <td>
                            <span class="p-column-title">Create By</span>
                            {{ contractList.createdBy }}
                        </td>
                        <td>
                          <span class="p-column-title">Data</span>
                          {{ contractList.createdDate  | date: 'MM/dd/yyyy' }}
                      </td>
                      <td>
                        <span class="p-column-title">Last Upadte</span>
                        {{contractList.updateDate | date: 'MM/dd/yyyy'}}
                      </td>
                        <td>

                            <span class="p-column-title">Status</span>
                            <p-tag [value]="contractList.status" [severity]="getSeverity(contractList.status)"></p-tag>
                        </td>
                        <!-- <td>
                            <span class="p-column-title">Activity</span>
                            <p-progressBar [value]="contractList.activity" [showValue]="false"></p-progressBar>
                        </td>
                        <td class="p-column-title">
                          <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': contractList.verified, 'text-red-500 pi-times-circle': !contractList.verified }"></i>
                      </td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No contractLists found.</td>
                    </tr>
                </ng-template>
                
            </p-table>
        </div>
          
      

   
     

      </div>
 
    </mat-card-content>
    </mat-card>
</div>